import { Mark } from '@tiptap/core';

// Allow for a custom element <success> in the markup. 
const Success = Mark.create({
    name: 'success',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'success',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['success', HTMLAttributes /* core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)*/, 0];
    },
    addCommands() {
        return {
        };
    },
    addKeyboardShortcuts() {
        return {};
    },
    addInputRules() {
        return [
        ];
    },
    addPasteRules() {
        return [];
    },
});


export { Success, Success as default };